import React, { useEffect, useState } from "react";

export default function PaymentGatewayLauncher() {
  const [paymentUrl, setPaymentUrl] = useState("");

  useEffect(() => {
    const raw = window.location.search;
    if (raw.startsWith("?url=")) {
      setPaymentUrl(raw.substring(5));
    }
  }, []);

  useEffect(() => {
    const setHeight = () => {
      document.documentElement.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    setHeight();
    window.addEventListener("resize", setHeight);
    return () => window.removeEventListener("resize", setHeight);
  }, []);

  const goBack = () => {
    window.history.replaceState(null, null, window.location.href);
    window.history.back();
  };

  return (
    <div style={{ margin: 0, padding: 0, height: "var(--app-height, 100vh)", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <header className="pg-header">
        <div className="pg-container">
          <div className="pg-button-container">
            <button onClick={goBack} className="pg-close-btn">Close</button>
          </div>
        </div>
      </header>

      <iframe
        id="gameIframe"
        src={paymentUrl}
        title="payment-gateway"
        frameBorder="0"
        style={{ display: "block", width: "100%", flex: 1, border: "none", minHeight: 0 }}
      />

      <style>{`
        html, body, #root {
          height: 100%;
          overflow: hidden;
          margin: 0;
          padding: 0;
        }
        .pg-header {
          height: 8vh;
          width: 100%;
          box-sizing: border-box;
        }
        .pg-container {
          width: 100%;
          height: 100%;
          background-color: black;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .pg-button-container {
          display: flex;
          align-items: center;
        }
        .pg-close-btn {
          color: white;
          font-family: Verdana, Geneva, sans-serif;
          font-size: 2.8vh;
          margin-right: 30px;
          padding: 10px;
          background-color: grey;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }
        @media screen and (max-width: 600px) {
          .pg-close-btn {
            font-size: 2.6vh;
            margin-right: 15px;
          }
        }
      `}</style>
    </div>
  );
}
